import { NgModule } from '@angular/core';
import { ToSystemPlusTimeAsyncPipe } from './to-system-plus-time-async.pipe';

@NgModule({
  declarations: [ToSystemPlusTimeAsyncPipe],
  exports: [ToSystemPlusTimeAsyncPipe],
})
export class ToSystemPlusTimeAsyncPipeModule {}
